// var geocoder = new google.maps.Geocoder;
var INFO_API = 'https://www.googleapis.com/civicinfo/v2/representatives';

//get rid of API Key later lol
let API_KEY = 'AIzaSyBYlN6AnQGw_v5T0aJxkKpYgR-4_5hkJdM';
let DEBUG = false;

// parsing out division IDs
var federal_pattern = "ocd-division/country:us";
var state_pattern = /ocd-division\/country:us\/state:(\D{2}$)/;
var cd_pattern = /ocd-division\/country:us\/state:(\D{2})\/cd:/;
var sl_pattern = /ocd-division\/country:us\/state:(\D{2})\/(sldl:|sldu:)/;
var county_pattern = /ocd-division\/country:us\/state:\D{2}\/county:\D+/;
var local_pattern = /ocd-division\/country:us\/state:\D{2}\/place:\D+/;
var district_pattern = /ocd-division\/country:us\/district:\D+/;

var federal_offices = ['United States Senate', 'United States House of Representatives', 'U.S. Senator', 'U.S. Representative']

var social_icon_lookup = {
    'YouTube': 'youtube',
    'Facebook': 'facebook',
    'Twitter': 'twitter',
    'GooglePlus': 'google-plus'
};

var social_link_lookup = {
    'YouTube': 'https://www.youtube.com/user/',
    'Facebook': 'https://www.facebook.com/',
    'Twitter': 'https://twitter.com/',
    'GooglePlus': 'https://plus.google.com/'
};

var selected_state = '';
var selected_county = '';
var selected_local = '';
var all_people = {};
var pseudo_id = 1;

export function getRepresentatives(addressString, callback) {
    var params = new URLSearchParams({
        'key': API_KEY,
        'address': addressString
    });
    //fetch from the google rep api
    fetch(INFO_API + "?" + params.toString(),  {mode: 'cors'})
    .then((r) => {
        return r.json().then(data => [r.status, data])
    })
    .then((data) => {
        if (data[0] === 200){
            callback(parseAPIResponse(data[1]));
        } else{
            console.log(data[1])
            callback({'error': true});
        }
    })
    .catch(err => {
        console.log(err);
    });
}

//parse the google api response
export function parseAPIResponse(data){
    var divisions = data['divisions'];
    var officials = data['officials'];
    var offices = data['offices'];

    selected_state = '';
    selected_county = '';
    selected_local = '';
    all_people = {};
    pseudo_id = 1;

    var federal_people = [];
    var state_people = [];
    var county_people = [];
    var local_people = [];

    if (DEBUG) {
        console.log(data);
        console.log(divisions);
    }

    if (divisions === undefined) {
        console.log('no data bruh');
    }
    else {
        Object.keys(divisions).forEach(function(division_id){
            let division = divisions[division_id];
            if (DEBUG) console.log(division.name);
            if (typeof division.officeIndices !== 'undefined'){
                division.officeIndices.forEach(function(office){
                    var office_name = offices[office];
                    offices[office]['officialIndices'].forEach(function(official){
                        var info = {
                            'person': null,
                            'office': office_name,
                            'address': null,
                            'channels': null,
                            'phones': null,
                            'urls': null,
                            'emails': null,
                            'division_id': division_id,
                            'pseudo_id': pseudo_id
                        };

                        if (DEBUG) console.log(officials[official])
                        var person = officials[official];
                        info['person'] = person;

                        if (typeof person.channels !== 'undefined'){
                            var channels = [];
                            person.channels.forEach(function(channel){
                                if (channel.type != 'GooglePlus' && channel.type != 'YouTube') {
                                    channel['icon'] = social_icon_lookup[channel.type];
                                    channel['link'] = social_link_lookup[channel.type] + channel['id'];
                                    channels.push(channel);
                                }
                            });
                            info['channels'] = channels;
                        }
                        if (typeof person.address !== 'undefined'){
                            info['address'] = person.address;
                        }
                        if (typeof person.phones !== 'undefined'){
                            info['phones'] = person.phones;
                        }
                        if (typeof person.urls !== 'undefined'){
                            info['urls'] = person.urls;
                        }
                        if (typeof person.emails !== 'undefined'){
                            info['emails'] = person.emails;
                        }
                        if(checkFederal(division_id, office_name)) {
                            info['jurisdiction'] = 'Federal Government';
                            federal_people.push(info);
                        } else if (checkState(division_id)) {
                            info['jurisdiction'] = selected_state;
                            state_people.push(info);
                        } else if (checkCounty(division_id)){
                            info['jurisdiction'] = selected_county;
                            county_people.push(info);
                        } else {
                            info['jurisdiction'] = selected_local;
                            local_people.push(info);
                        }
                        all_people[pseudo_id] = info;
                        pseudo_id = pseudo_id + 1;
                    });
                });
            }
        });
    }

    let address_string = Object.keys(data.normalizedInput).map(function(key) {
        if(!!data.normalizedInput[key]) return data.normalizedInput[key];
    }).join(" ");
    let response = {
        federal: federal_people,
        state: state_people,
        county: county_people,
        local: local_people,
        user_location: address_string,
        senators: federal_people.filter(person => "U.S. Senator" === person.office.name),
        representatives: federal_people.filter(person => ("U.S. Representative" === person.office.name))
    }
    return response;
}

function findMe() {
    var foundLocation;
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            var latitude = position.coords.latitude;
            var longitude = position.coords.longitude;
            var accuracy = position.coords.accuracy;
            var coords = new google.maps.LatLng(latitude, longitude);

            if (DEBUG) console.log(coords);

            geocoder.geocode({
                'location': coords
            }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    if (results[1]) {
                        $("#address").val(results[1].formatted_address);
                        addressSearch();
                    }
                }
            });

        }, function error(msg) {
            alert('Please enable your GPS position feature.');
        }, {
            //maximumAge: 600000,
            //timeout: 5000,
            enableHighAccuracy: true
        });
    } else {
        alert("Geolocation API is not supported in your browser.");
    }
};

function checkFederal(division_id, office_name) {
    if( division_id == federal_pattern ||
        cd_pattern.test(division_id) ||
        federal_offices.indexOf(office_name.name) >= 0)
        return true;
    else
        return false;
}

function checkState(division_id){
    if( state_pattern.test(division_id) ||
        sl_pattern.test(division_id))
        return true;
    else
        return false;
}

function checkCounty(division_id){
    if( county_pattern.test(division_id))
        return true;
    else
        return false;
}

function formatParty(party) {
    if (party) {
        if (party == 'Unknown')
            return '';

        var party_letter = party.charAt(0);
        var css_class ='label-ind';
        if (party_letter == 'D')
            css_class ='label-dem';
        else if (party_letter == 'R')
            css_class ='label-rep';

        return "(<span title='" + party + "' class='" + css_class + "'>" + party_letter + "</span>)";
    }
    else
        return '';
}

function toTitleCase(str)
{
    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}

//converts a slug or query string in to readable text
function convertToPlainString(text) {
    if (text === undefined) return '';
    return decodeURIComponent(text);
}